module.exports = __webpack_public_path__ + "static/house2-c9726f5c6c689752e55a03ab288649be.jpg";